const SelectOptionsMixin = {
  methods: {
    getConvertedOptions(options) {
      return options.map((option) => {
        if (typeof option !== 'object') {
          return {
            text: option.toString(),
            value: option.toString(),
          };
        }

        return option;
      });
    },
    getOptionByValue(value, options) {
      return options.find((option) => option.value === value);
    },
  },
};

export default SelectOptionsMixin;
